export default {
    'TablaFlujo.AnularDocumento': 'Flows',
    'TablaFlujo.Acciones': 'Actions',
    'TablaFlujo.Estado': 'State',
    'TablaFlujo.Descripcion': 'Description',
};
